import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";

import ReloadIcon from "../../assets/icons/ReloadIcon";
import {
  doSetOriginalCode,
  doSetOriginalReactCode
} from "../../redux/reducers";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
`;

class CodeNavigator extends Component {
  static propTypes = {
    activeChapterId: PropTypes.number,
    codeId: PropTypes.string,
    type: PropTypes.string,
    setOriginalCode: PropTypes.func.isRequired,
    setOriginalReactCode: PropTypes.func.isRequired
  };

  onSetOriginalCode = () => {
    const {
      setOriginalCode,
      setOriginalReactCode,
      activeChapterId,
      codeId,
      type = null
    } = this.props;
    if (type === "react") {
      setOriginalReactCode(activeChapterId, codeId);
    } else {
      setOriginalCode(activeChapterId, codeId);
    }
  };

  render() {
    const { activeChapterId, codeId } = this.props;

    return (
      <Wrapper>
        <ReloadIcon
          onClick={this.onSetOriginalCode}
          activeChapterId={activeChapterId}
          codeId={codeId}
        />
      </Wrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setOriginalCode: (activeChapterId, codeId) =>
    dispatch(doSetOriginalCode(activeChapterId, codeId)),
  setOriginalReactCode: (activeChapterId, codeId) =>
    dispatch(doSetOriginalReactCode(activeChapterId, codeId))
});

export default connect(null, mapDispatchToProps)(CodeNavigator);



// WEBPACK FOOTER //
// ./src/book/blocks/CodeNavigator.js